export default "__VITE_ASSET__CR23sK55__"